<div class="box">
  <div class="pin">
    <input
      #pinInput
      type="password"
      inputmode="numeric"
      pattern="\d*"
      maxlength="4"
      autocomplete="one-time-code"
      (input)="formatPin($event)"
      class="pin-input"
      [disabled]="disabled"
    />

    @for (i of [0, 1, 2, 3]; track i) {
      <div class="pin-circle" [class.filled]="i < pinValue().length" aria-hidden="true"></div>
    }
  </div>
</div>
